import React from "react";
import {
  InfoProvisionGuideWrapper,
  InfoTitleWrapper,
  InfoProvisionContainer,
  InfoContentWrapper,
} from "./InfoProvisionGuideStyle";
import CloseSvg from "assets/icons/close-black.svg";
import { useDispatch, useSelector } from "react-redux";
import { toggleModal } from "redux/modules/dashboard";

const InfoProvisionGuideModal = ({ top, left }) => {
  const isModal = useSelector((state) => state.dashboard.isModal);
  const dispatch = useDispatch();

  return (
    <InfoProvisionGuideWrapper>
      <div
        className={isModal ? "isModal" : ""}
        onClick={() => {
          dispatch(toggleModal());
        }}
      >
        <InfoProvisionContainer
          infoTop={`${top + 26}px`}
          infoLeft={`${left - 300}px`}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <InfoTitleWrapper>
            <h2>정보 제공 안내</h2>
            <img
              src={CloseSvg}
              alt="close button"
              onClick={(e) => {
                dispatch(toggleModal());
                e.stopPropagation();
              }}
            />
          </InfoTitleWrapper>
          <InfoContentWrapper>
            <p>
              <span>다양한 데이터를 결합하여</span> 꽃의 가격과 구매 가능성을
              예측하여 제공해드려요.
            </p>
            <p>
              꽃 시세는 화훼유통정보의 <span>‘일자별 경매정보' 데이터</span>를
              활용하여 제공하고 있어요.
            </p>
            <p>
              본 정보는 <span>경매가에 기반</span>하기 때문에,{" "}
              <span>
                실제 시장에서 도매 사장님들이 판매하는 가격은 조금 더 높을 수
                있으니 참고용
              </span>
              으로만 활용해주세요.
            </p>
          </InfoContentWrapper>
        </InfoProvisionContainer>
      </div>
    </InfoProvisionGuideWrapper>
  );
};

export default InfoProvisionGuideModal;
